import React from 'react';
import LoginForm from './LoginForm';

const AuthContainer: React.FC = () => {
  return <LoginForm />;
};

export default AuthContainer;
